import { useContext } from 'react'
import { HistoryContext } from '../contexts'

export const useRouter = () => {
  return useContext(HistoryContext)
}
